module.exports = __webpack_public_path__ + "static/media/google-wallet.15ac0a84.svg";